import { useState, useLayoutEffect, useCallback } from 'react';
import type { RecentPanelRect } from './types';

export interface UseRecentPanelProps {
  focused: boolean;
  recentForPortalCount: number;
  sidebarRowsCount: number;
  wrapperRef: React.RefObject<HTMLDivElement | null>;
}

export interface UseRecentPanelReturn {
  recentPanelRect: RecentPanelRect | null;
}

export function useRecentPanel({
  focused,
  recentForPortalCount,
  sidebarRowsCount,
  wrapperRef,
}: UseRecentPanelProps): UseRecentPanelReturn {
  const [recentPanelRect, setRecentPanelRect] = useState<RecentPanelRect | null>(null);

  const updateRect = useCallback((): void => {
    if (!wrapperRef.current) return;
    const r = wrapperRef.current.getBoundingClientRect();
    setRecentPanelRect({ top: r.bottom + 8, left: r.left, width: r.width });
  }, [wrapperRef]);

  useLayoutEffect(() => {
    if (!focused || recentForPortalCount === 0) {
      setRecentPanelRect(null);
      return;
    }
    updateRect();
    window.addEventListener('scroll', updateRect, true);
    window.addEventListener('resize', updateRect);
    return () => {
      window.removeEventListener('scroll', updateRect, true);
      window.removeEventListener('resize', updateRect);
    };
  }, [focused, recentForPortalCount, sidebarRowsCount, updateRect]);

  return { recentPanelRect };
}
